export const MODERATION_STATUS_NEW: number = 1;
export const MODERATION_STATUS_SUCCESS: number = 2;
export const MODERATION_STATUS_REJECT: number = 3;
export const FIRST_MODERATION_STATUS_SUCCESS: number = 3;
export const LAWYER_APPLICATIONS_VISIBLE_STATUS: number = 1;
export const LAWYER_MODERATION_COUNT_FIELDS: number = 18;
export const ADVOCATE_MODERATION_COUNT_FIELDS: number = 19;
export const COMPANY_LAWYER_MODERATION_COUNT_FIELDS: number = 22;
export const COMPANY_ADVOCATE_MODERATION_COUNT_FIELDS: number = 23;
export const VERIFICATED_LAWYER_STATUS: number = 1;
export const STATUS_PROFILE_NEW: number = 1;
export const STATUS_PROFILE_FILLED: number = 2;
